import cacheSmartReplyDataAction from '../actions/cacheSmartReplyDataAction';
import { SmartReplyData, SmartReplySuggestion } from 'owa-mail-store';
import { ClientItem } from 'owa-mail-store';
import { ObservableMap } from 'mobx';
import { mutator } from 'satcheljs';

export default mutator(cacheSmartReplyDataAction, function cacheSmartReplyData(actionMessage: {
    item: ClientItem;
    validPropertyExists: boolean;
    smartReplies?: SmartReplySuggestion[];
    loggableSmartReplies?: string[];
    smartReplyExtractionID?: string;
}) {
    // Null/false for these properties means we didn't find a valid property on the item.
    // We assign these values so that we don't bother fetching the property again.
    let smartReplyData: SmartReplyData = {
        SmartReplies: null,
        LoggableSmartReplies: null,
        ExtractionID: null,
        SuggestionAppropriatenessMap: null,
        FeedbackSubmitted: false,
    };

    const {
        item,
        validPropertyExists,
        smartReplies,
        loggableSmartReplies,
        smartReplyExtractionID,
    } = actionMessage;

    if (validPropertyExists) {
        smartReplyData = {
            SmartReplies: smartReplies,
            LoggableSmartReplies: loggableSmartReplies,
            ExtractionID: smartReplyExtractionID,
            SuggestionAppropriatenessMap: new ObservableMap<string, string>(),
            FeedbackSubmitted: false,
        };

        // Initialize appropriateness map, which maps smart reply index to appropriateness.
        // Empty string -> not inappropriate
        // Smart reply itself -> inappropriate
        for (let i = 0; i < smartReplies.length; i++) {
            const index = String(i);
            smartReplyData.SuggestionAppropriatenessMap.set(index, '');
        }
    }

    item.SmartReplyData = smartReplyData;
});
